import { render, staticRenderFns } from "./menu-mobile.vue?vue&type=template&id=c764bfbe"
import script from "./menu-mobile.vue?vue&type=script&lang=js"
export * from "./menu-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports